// Smooth scroll, driven by the GSAP ticker so ScrollTrigger and Lenis share one clock.
import Lenis from 'lenis'
import { G, ST } from './misc'

export function createLenis(): Lenis {
  const lenis = new Lenis({ lerp: 0.085, smoothWheel: true })
  lenis.on('scroll', ST.update)
  G.ticker.add((t) => lenis.raf(t * 1000))
  G.ticker.lagSmoothing(0)
  return lenis
}
